import { useEffect, useRef } from 'react';

/**
 * Re-runs `refetch` on a timer while `enabled` is true.
 *
 * The fetch reference is mirrored into a ref so callers can recreate the
 * function (via useCallback deps changing) WITHOUT restarting the interval.
 * Only `enabled` and `intervalMs` reset the timer.
 */
export function useAutoRefresh(
  refetch: () => void | Promise<void>,
  enabled: boolean,
  intervalMs: number
): void {
  const refetchRef = useRef(refetch);

  useEffect(() => {
    refetchRef.current = refetch;
  }, [refetch]);

  useEffect(() => {
    if (!enabled || intervalMs <= 0) return;
    const id = window.setInterval(() => {
      void refetchRef.current();
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [enabled, intervalMs]);
}
